module.exports = __webpack_public_path__ + "img/blackred.886f66d9.png";